// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.screenfull-svg[data-v-58b253b4] {\n  display: inline-block;\n  cursor: pointer;\n  fill: #35628a;\n  width: 20px;\n  height: 20px;\n  vertical-align: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
